export default __webpack_public_path__ + "static/images-d1adfaee61551fd73124a89e0eb90b25.jpg";